import React, { useState, useEffect } from "react";
import { firestore } from "./firebase/firebase";
import { useAuth } from "./firebase/AuthContext";
import { loadStripe } from "@stripe/stripe-js";
import { Button, CircularProgress } from "@material-ui/core";

function PlansScreen(props) {
  const [products, setProducts] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stripeId, setStripeId] = useState("");

  const { currentUser } = useAuth();

  const handleCustomerPortalClick = async () => {
    setIsLoading(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_PORTAL}/create-portal-link`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          returnUrl: window.location.origin,
          locale: 'auto',
          userId: `${stripeId}`
        }),
      });
  
      const { url } = await response.json();
      window.location.assign(url);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  //this gets the stripe id for the user
  useEffect(() => {
    const unsubscribe = firestore
      .collection("customers")
      .doc(currentUser.uid)
      .onSnapshot((doc) => {
        const data = doc.data();
        setStripeId(data?.stripeId || ""); // set stripeId state
      });

    return unsubscribe; // cleanup the listener
  }, [currentUser.uid]);


  /*

  //This is meant to so the users subscription
  useEffect(()=>{
    firestore.collection('customers')
    .doc(currentUser.uid)
    .collection('subscriptions')
    .where('status', 'in', ['trialing', 'active'])
    .onSnapshot(async (snapshot) => {
      // In this implementation we only expect one active or trialing subscription to exist.
      const doc = snapshot.docs[0];
      console.log(doc.id, ' => ', doc.data());
      //setID()
    });
  })
  */
  
  //This allows users to change their subscription
  useEffect(() => {
    firestore
  .collection("customers")
  .doc(currentUser.uid)
  .collection("subscriptions")
  .get()
  .then((querySnapshot) => {
    querySnapshot.forEach(async (subscriptionDoc) => {
      //console.log(subscriptionDoc.data()); // Add this line to check the data
      setSubscription({
        id: subscriptionDoc.id,
        status: subscriptionDoc.data().status,
        current_period_end: subscriptionDoc.data().current_period_end.seconds,
        current_period_start: subscriptionDoc.data().current_period_start.seconds,
        suggestions: subscriptionDoc.data().items[0].price.product.metadata.Suggestions,
        summaries: subscriptionDoc.data().items[0].price.product.metadata.Summaries,

      });
    });
  })
  .catch((error) => {
    console.log("Error getting subscriptions: ", error);
  });

  }, [currentUser.uid]);


   //gives subscription details to parent component 'drawer'
  // props.sub(subscription);

  //this lists all the products
  useEffect(() => {
    firestore
      .collection("products")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const productsData = {};
        querySnapshot.forEach(async (productDoc) => {
          productsData[productDoc.id] = productDoc.data();
          const priceSnap = await productDoc.ref.collection("prices").get();
          priceSnap.docs.forEach((price) => {
            productsData[productDoc.id].prices = {
              priceId: price.id,
              priceData: price.data(),
            };
          });
        });
        setProducts(productsData);
        // console.log(productsData);
      })
      .catch((error) => {
        console.log("Error getting products: ", error);
      });
  }, []);

  // console.log(products);
  //console.log(subscription);


  //this allows people get to the subscriptions

  const loadCheckout = async (priceId) => {
    setIsLoading(true);
    setLoading(true);
  
    // Check if user already has an active subscription
    if (subscription && subscription.status === "active") {
      alert("You already have an active subscription");
      setIsLoading(false);
      setLoading(false);
      return;
    }
  
    // Check if user is already subscribed to the selected plan
    if (
      subscription &&
      subscription.status !== "canceled"
    ) {
      alert(`You are already subscribed to the plan`);
      setIsLoading(false);
      setLoading(false);
      return;
    }
  
    // Create a new checkout session for the selected plan
    const docRef = await firestore
      .collection("customers")
      .doc(currentUser.uid)
      .collection("checkout_sessions")
      .add({
        price: priceId,
        success_url: window.location.origin,
        cancel_url: window.location.origin,
      });
  
    docRef.onSnapshot(async (snap) => {
      const { error, sessionId } = snap.data();
  
      if (error) {
        // Handle checkout session creation errors
        console.error(`Checkout session creation error: ${error.message}`);
        alert(`An error occurred: ${error.message}`);
        setIsLoading(false);
        setLoading(false);
        return;
      }
  
      if (sessionId) {
        // Init Stripe
        const stripe = await loadStripe(
          `${process.env.REACT_APP_STRIPE}`
        );
  
        // Redirect to checkout
        stripe.redirectToCheckout({ sessionId });
      }
    });
  };
  

  const handleH1Click = () => {
    const currentSummaries = parseInt(subscription.summaries);
    const currentSuggestions = parseInt(subscription.suggestions);
    const updatedSummaries = currentSummaries - 1;
    const updatedSuggestions = currentSuggestions - 1;
  
    console.log(updatedSummaries, updatedSuggestions);
  
    const subscriptionDocRef = firestore
      .collection("customers")
      .doc(currentUser.uid)
      .collection("subscriptions")
      .doc(subscription.id);
  
    subscriptionDocRef
      .update({
        "items.0.price.product.metadata.Summaries": updatedSummaries.toString(),
        "items.0.price.product.metadata.Suggestions": updatedSuggestions.toString(),
      })
      .then(() => {

        setSubscription(prevState => ({
            ...prevState,
            summaries: updatedSummaries.toString(),
            suggestions: updatedSuggestions.toString()
          }));

        console.log("Subscription updated successfully!");
      })
      .catch((error) => {
        console.error("Error updating subscription:", error);
      });

  };
  

  
  
  return (
    <div className="plansScreen">
      {Object.entries(products).map(([productId, productData]) => {
        // TODO: add some logic to check if the user's subscription is active...
        return (
          <div className="plansScreen_plan" key={productId}>
            <div className="plansScreen_info">
            </div>
            {subscription === null || subscription.status === 'canceled' ? (

  <Button
    disabled={isLoading}
    onClick={() => loadCheckout(productData.prices.priceId)}
    style={{ backgroundColor: '#D1B000', color:'white',fontFamily: 'Inter', marginLeft: '10px', marginTop: '10px' }}
  >
    {isLoading && (
      <CircularProgress
        size={24}
        style={{ color:'white',fontFamily: 'Inter', marginLeft: '10px' }}
      />
    )}
    {isLoading ? "" : "Go Pro"}
  </Button>
) : (
<>
  <h5
    disabled={isLoading}
    onClick={handleCustomerPortalClick}
    style={{ color: "#7E3AF2", fontFamily: "Inter", marginLeft: "10px", cursor: 'pointer' }}
  >
    {isLoading && (
      <CircularProgress
        size={24}
        style={{ color:'#7E3AF2',fontFamily: 'Inter', marginLeft: '10px' }}
      />
    )}
    {isLoading ? "" : "Manage Subscription"}
  </h5>
  </>
)}






          </div>
        );
      })}
    </div>
  );
  
      
  }
  
  export default PlansScreen;
  